import React from 'react';
import PropTypes from 'prop-types';
import { Paragraph } from 'components/core/Typography';

export default function ReviewText({ reviewText }) {
	return (
		<Paragraph className="review-text">
			{reviewText}
		</Paragraph>
	);
}

ReviewText.propTypes = {
	reviewText: PropTypes.string.isRequired
};
